import React from 'react';
import Icon from 'components/AppIcon';

export default function ComparisonTable({ data }) {
  return (
    <div className="bg-[rgba(255,255,255,0.03)] border border-[rgba(0,229,255,0.1)] rounded-xl p-5">
      <h3 className="text-[#E2E8F0] font-semibold text-sm mb-4">Month-over-Month Comparison</h3>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-[rgba(255,255,255,0.06)]">
              <th className="text-left text-xs text-[#64748B] pb-2 font-medium">Category</th>
              <th className="text-right text-xs text-[#64748B] pb-2 font-medium">Last Month</th>
              <th className="text-right text-xs text-[#64748B] pb-2 font-medium">This Month</th>
              <th className="text-right text-xs text-[#64748B] pb-2 font-medium">Change</th>
              <th className="text-center text-xs text-[#64748B] pb-2 font-medium">Trend</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((row) => {
              const change = row?.lastMonth > 0 ? ((row?.thisMonth - row?.lastMonth) / row?.lastMonth) * 100 : 0;
              const isUp = change > 0;
              const isDown = change < 0;
              return (
                <tr key={row?.category} className="border-b border-[rgba(255,255,255,0.04)] hover:bg-[rgba(255,255,255,0.02)] transition-colors">
                  <td className="py-2.5 text-[#E2E8F0] font-medium">{row?.category}</td>
                  <td className="py-2.5 text-right font-mono text-[#94A3B8]">${row?.lastMonth?.toLocaleString()}</td>
                  <td className="py-2.5 text-right font-mono text-[#E2E8F0]">${row?.thisMonth?.toLocaleString()}</td>
                  <td className={`py-2.5 text-right font-mono text-xs ${isUp ? 'text-[#EF4444]' : isDown ? 'text-[#10B981]' : 'text-[#64748B]'}`}>
                    {change > 0 ? '+' : ''}{change?.toFixed(1)}%
                  </td>
                  <td className="py-2.5 text-center">
                    {isUp ? <Icon name="TrendingUp" size={14} color="#EF4444" /> : isDown ? <Icon name="TrendingDown" size={14} color="#10B981" /> : <Icon name="Minus" size={14} color="#64748B" />}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
